export default __webpack_public_path__ + "static/media/chat.18d299c0.gif";